import {adminAxios} from '@/Plugins/Axios';

// Transit-time report (avg days from bill creation to destination-branch
// arrival). Lives under /api/admin — adminAxios' own baseURL — so unlike
// employeeRegistrationKpiService no baseURL override is needed.
export async function fetchTransitTimeReport(params = {}) {
    const response = await adminAxios.get('report/transit-time', {params});
    return response.data.data;
}
